import { render } from "./LoadingView.vue?vue&type=template&id=b39e999c&scoped=true&ts=true"
import script from "./LoadingView.vue?vue&type=script&lang=ts"
export * from "./LoadingView.vue?vue&type=script&lang=ts"

import "./LoadingView.vue?vue&type=style&index=0&id=b39e999c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b39e999c"]])

export default __exports__